/*Filter returns true if error message should be filtered*/
const sentryFilter = (event, hint) => {
  if (hint) {
    // we don't care about network connection errors
    const error = hint.originalException;
    let errorMessage;
    if (typeof error === "string") {
      errorMessage = error;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    }

    switch (errorMessage) {
      // aws amplify throws this when the user navigates before the sign-up components loads
      case "NetworkError when attempting to fetch resource.":
      case "Network request failed":
        console.log("filtering error on message:", errorMessage);
        return true;
      default:
        break;
    }
  }
};

export default sentryFilter;
